export const TUNASYNC_JSON_PATH = "/static/tunasync.json";
export const ISOINFO_JSON_PATH = "/static/status/isoinfo.json";
export const DISKINFO_JSON_PATH = "/static/status/disk.json";
